// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Breadcrumb_bread-crumb__6pkyZ {
  font-size: 25px;
  display: flex;
  margin-left: -10px;
  margin-bottom: 20px;
}
.Breadcrumb_bread-crumb__6pkyZ .Breadcrumb_breadcrumb-inner-item__Zk9ja {
  display: flex;
}
.Breadcrumb_bread-crumb__6pkyZ .Breadcrumb_breadcrumb-inner-item__Zk9ja span {
  padding: 5px 0px;
  width: 25px;
  text-align: center;
  color: rgba(0, 0, 0, 0.45);
}
.Breadcrumb_bread-crumb__6pkyZ .Breadcrumb_breadcrumb-inner-item__Zk9ja .Breadcrumb_breadcrumb-item__Pd1jc {
  padding: 5px 10px;
}
.Breadcrumb_bread-crumb__6pkyZ .Breadcrumb_breadcrumb-inner-item__Zk9ja .Breadcrumb_breadcrumb-item__Pd1jc a {
  color: rgba(0, 0, 0, 0.45) !important;
  text-decoration: none;
}
.Breadcrumb_bread-crumb__6pkyZ .Breadcrumb_breadcrumb-inner-item__Zk9ja .Breadcrumb_breadcrumb-item__Pd1jc:hover {
  color: black;
  background: rgba(0, 0, 0, 0.1);
  cursor: pointer;
  border-radius: 3px;
}
.Breadcrumb_bread-crumb__6pkyZ .Breadcrumb_breadcrumb-last-item__XEd6T {
  padding: 5px 10px;
}
.Breadcrumb_bread-crumb__6pkyZ .Breadcrumb_breadcrumb-last-item__XEd6T a {
  color: black !important;
  text-decoration: none;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/SuperAdmin/Layout/Content/Components/Breadcrumb/Breadcrumb.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AACF;AAAE;EACE,aAAA;AAEJ;AADI;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,0BAAA;AAGN;AADI;EACE,iBAAA;AAGN;AAFM;EACE,qCAAA;EACA,qBAAA;AAIR;AADI;EACE,YAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;AAGN;AAAE;EACE,iBAAA;AAEJ;AADI;EACE,uBAAA;EACA,qBAAA;EACA,gBAAA;AAGN","sourcesContent":[".bread-crumb {\n  font-size: 25px;\n  display: flex;\n  margin-left: -10px;\n  margin-bottom: 20px;\n  .breadcrumb-inner-item {\n    display: flex;\n    span {\n      padding: 5px 0px;\n      width: 25px;\n      text-align: center;\n      color: rgba(0, 0, 0, 0.45);\n    }\n    .breadcrumb-item {\n      padding: 5px 10px;\n      a {\n        color: rgba(0, 0, 0, 0.45) !important;\n        text-decoration: none;\n      }\n    }\n    .breadcrumb-item:hover {\n      color: black;\n      background: rgba(0, 0, 0, 0.1);\n      cursor: pointer;\n      border-radius: 3px;\n    }\n  }\n  .breadcrumb-last-item {\n    padding: 5px 10px;\n    a {\n      color: black !important;\n      text-decoration: none;\n      font-weight: 600;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bread-crumb": `Breadcrumb_bread-crumb__6pkyZ`,
	"breadcrumb-inner-item": `Breadcrumb_breadcrumb-inner-item__Zk9ja`,
	"breadcrumb-item": `Breadcrumb_breadcrumb-item__Pd1jc`,
	"breadcrumb-last-item": `Breadcrumb_breadcrumb-last-item__XEd6T`
};
export default ___CSS_LOADER_EXPORT___;
